// Progresso da jornada de primeiro acesso para a NAVEGAÇÃO (sidebar e drawer
// mobile): quantos passos já foram e se ainda há pendência acionável.
//
// Reaproveita o MESMO `useJourney` do JourneyCard (chave ["onboarding",
// "journey"]), então o menu não gera requisição extra na Home — e os dois nunca
// divergem.
import { mergeJourney, temPendencia } from "@/journey-model";
import { useAccessSnapshot } from "./use-viewer-role";
import { useJourney } from "./use-onboarding";

export type JourneyProgress = { done: number; total: number; pendente: boolean };

// null enquanto carrega, sem marca ativa ou com payload quebrado: o menu volta
// ao normal (item no fim, sem badge) em vez de piscar um contador errado.
export function useJourneyProgress(): JourneyProgress | null {
  const access = useAccessSnapshot();
  const { data } = useJourney();
  if (!data || !Array.isArray(data.steps) || typeof data.total !== "number") return null;
  return {
    done: data.done,
    total: data.total,
    // Um passo `todo` fora do alcance da permissão (ex.: gerente vendo "team",
    // que é só diretor) não pode travar o destaque da navegação para sempre —
    // por isso o acesso entra aqui, do mesmo jeito que já entrava em /journey.
    pendente: temPendencia(mergeJourney(data), access),
  };
}
